import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { companyAccountStatus, getExpiryDateFromTokenBoolean, getPermissionFromToken } from 'core/apis/common';

const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const VisitorManagement = Loadable(lazy(() => import('views/Visitor')));
const AppointmentManagement = Loadable(lazy(() => import('views/Appointment')));
const PassesManagement = Loadable(lazy(() => import('views/Passes')));
const Calender = Loadable(lazy(() => import('views/Calender')));
const UserManagement = Loadable(lazy(() => import('views/User')));
const ReportManagement = Loadable(lazy(() => import('views/Report')));
const Configure = Loadable(lazy(() => import('views/Configure')))
const CompanyProfile = Loadable(lazy(() => import('views/CompanyProfile')))
const AllEntry = Loadable(lazy(() => import('views/AllEntry')))
const EntriesManagemenmt = Loadable(lazy(() => import('views/Entries')))
const ViewUserDetails = Loadable(lazy(() => import('views/User/ViewUserDetails')))
const ViewVisitorDetails = Loadable(lazy(() => import('views/Visitor/ViewVisitorDetails')))
const UpgradePackage = Loadable(lazy(() => import('views/UpgragePackage')))

const employeePermissions = getPermissionFromToken();

let checkDashboard = true
const active = companyAccountStatus();
if (!active) {
  checkDashboard = false
}
const checkExpiry = getExpiryDateFromTokenBoolean();
if (checkExpiry) {
  checkDashboard = false
}

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: '/*',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
        employeePermissions?.includes('visitor') && {
          path: 'visitor',
          element: <VisitorManagement />,
        },
        employeePermissions?.includes('visitor') && {
          path: 'visitor/fulldetails/:visitorid',
          element: <ViewVisitorDetails />
        },
        employeePermissions?.includes('appointment') && {
          path: 'appointment',
          element: <AppointmentManagement />
        },
        employeePermissions?.includes('pass') && {
          path: 'pass',
          element: <PassesManagement />
        },
        employeePermissions?.includes('allEntry') && {
          path: 'allentry',
          element: <AllEntry />
        },
        employeePermissions?.includes('calender') && {
          path: 'calendar',
          element: <Calender />
        },
        employeePermissions?.includes('profile') && {
          path: 'profile',
          element: <Configure />
        },
        employeePermissions?.includes('employee') && {
          path: 'user',
          element: <UserManagement />
        },
        employeePermissions?.includes('employee') && {
          path: 'user/fulldetails/:userid',
          element: <ViewUserDetails />
        },
        employeePermissions?.includes('report') && {
          path: 'report',
          element: <ReportManagement />
        },
        employeePermissions?.includes('manageEntry') && {
          path: 'manageentry',
          element: <EntriesManagemenmt />
        },
        employeePermissions?.includes('companyProfile') && {
          path: 'companyprofile',
          element: <CompanyProfile />
        },
        employeePermissions?.includes('upgradePackage') && {
          path: 'upgradepackage',
          element: <UpgradePackage />
        },
        {
          path: '*',
          element: <DashboardDefault />
        }
      ]
    }
  ]
};

const ExpireRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
        employeePermissions?.includes('companyProfile') && {
          path: 'companyprofile',
          element: <CompanyProfile />
        },
        employeePermissions?.includes('upgradePackage') && {
          path: 'upgradepackage',
          element: <UpgradePackage />
        },
        {
          path: '*',
          element: <DashboardDefault />
        }
      ]
    }
  ]
};

export default checkDashboard ? MainRoutes : ExpireRoutes;
